import React, { useEffect, useRef, useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebaseModel";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import LoginView from "../views/loginView";

const LoginPresenter = (props) => {
  const navigate = useNavigate();
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState(null); // State variable for error message

  const onLogin = (e) => {
    e.preventDefault();

    const email = emailRef.current.value;
    const password = passwordRef.current.value;

    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        navigate("/home");
      })
      .catch((error) => {
        const errorCode = error.code;
        setErrorMessage(errorCode); // Set error message state
      });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onLogin(e);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const back = () => {
    navigate("/");
  };

  const Login = observer(function LoginRender(props) {
    return (
      <LoginView
        onLogin={onLogin}
        emailRef={emailRef}
        passwordRef={passwordRef}
        errorMessage={errorMessage} // Pass error message to SignupView
        back={back}
      />
    );
  });

  return <Login />;
};

export default LoginPresenter;
